import React from "react";
import { getCompanyProfiles } from "shared/utils/companyUtils";
import { SimpleHeader } from "./SimpleHeader";

interface CompanyHeaderProps {
  company: server.dto.Company
}

export const CompanyHeader = ({ company }: CompanyHeaderProps) => {
  const profiles = getCompanyProfiles(company, site.currentEnvironment.functionGroups, RESX.Artist.NoLongerActive);

  return <SimpleHeader title={company.name} isDeleted={company.isDeleted}>
    {profiles.length > 0
      ? <div className="purple-header-text">{profiles.join(", ")}</div>
      : <div className="purple-header-text purple-header-light">{RESX.Company.NoProfileSet}</div>}
  </SimpleHeader>;
};
